import type { Exercise, Unit } from './course';

export function isExercise(item: Exercise | Unit): item is Exercise {
  return item.type === 'Exercise';
}

export function isUnit(item: Exercise | Unit): item is Unit {
  return item.type === 'Unit';
}
